import { render, staticRenderFns } from "./tbInfo.vue?vue&type=template&id=5b8112b0&"
import script from "./tbInfo.vue?vue&type=script&lang=js&"
export * from "./tbInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports